import React, { lazy } from 'react';
import { ActivateKit, KitStep, KitStepProps } from './ActivateKit';
import type { FC } from 'react';

const KitActivationStep = lazy(() => import('./steps/KitActivationStep'));
const MemberStep = lazy(() => import('./steps/MemberStep'));
const SampleDetailsStep = lazy(() => import('./steps/SampleDetailsStep'));
const PractitionerStep = lazy(() => import('./steps/PractitionerStep'));
const ResearchStep = lazy(() => import('./steps/ResearchStep'));
const VersionUpdateStep = lazy(() => import('./steps/VersionUpdateStep/VersionUpdateStep'));

export const registerKitSteps: readonly KitStep[] = [
  {
    id: 'kitActivationStep',
    Component: KitActivationStep as FC<KitStepProps>,
  },
  {
    id: 'memberStep',
    Component: MemberStep as FC<KitStepProps>,
    exactPath: true,
  },
  {
    id: 'sampleDetailsStep',
    Component: SampleDetailsStep as FC<KitStepProps>,
  },
  {
    id: 'practitionerStep',
    Component: PractitionerStep as FC<KitStepProps>,
    optional: true,
  },
  {
    id: 'versionUpdateStep',
    Component: VersionUpdateStep as FC<KitStepProps>,
  },
  {
    id: 'researchStep',
    Component: ResearchStep as FC<KitStepProps>,
    optional: true,
  },
] as const;

const KitActivationContainer = () => {
  // Pass the steps configuration down as a prop
  return <ActivateKit steps={registerKitSteps} />;
};

export default KitActivationContainer;
